'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwipeableDrawer = require('./SwipeableDrawer');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SwipeableDrawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/SwipeableDrawer/index.js
// module id = 1487
// module chunks = 35783957827783